<template>
	<div class="vue-parttern" :class="{ 'disabled' : disabled }" >
		<div class="vue-parttern-preview" @click.stop.prevent="show_modal = true">
			<template v-if="value">
				<img :src="`${parttern_path}/${value}`" alt="">
			</template>
		</div>
		<vue-modal v-model="show_modal" :backdrop="allow_modal_backdrop" @on-hide="onHideModal" width="800px" v-cloak>
			<template slot="modal-header">
				<div class="parttern-modal-header">
					<h5>Choose a pattern</h5>
				</div>
			</template>
			<template slot="modal-body">
				<div class="parttern-modal-body">
					<simplebar class="list-parttern">
						<div class="row">
							<div class="col col-6" v-for="(item, index) in parttern"  :key="`index_${index}`">
								<div class="item"  :class="{ 'is-actived' : isActive(item) }" @click.stop.prevent="select(item)" >
									<div class="item-image">
										<img :src="`${parttern_path}/${item}`" alt="">
									</div>
								</div>
							</div>
						</div>
					</simplebar>
				</div>
			</template>
			<template slot="modal-footer">
				<div class="parttern-modal-footer">
					<button class="btn btn-secondary" @click.stop.prevent="show_modal = false">Cancel</button>
					<button class="btn btn-primary" @click.stop.prevent="save" :disabled="!selected">Select</button>
				</div>
			</template>
		</vue-modal>
	</div>
</template>
<script>
import { mapGetters } from 'vuex'
import VueModal from './vue-modal'
export default {
	name : 'VueParttern',
	components:{
		VueModal
	},
	props :{
		value :{

		},
		disabled :{

		}
	},
	data(){
		return {
			show_modal : false,
			allow_modal_backdrop: true,
			selected: null
		}
	},
	computed:{
		...mapGetters({
			'parttern' : 'getParttern',
			'parttern_path' : 'auth/getPartternPath'
		})
	},
	methods:{
		onHideModal(){
			this.selected = null
		},
		select(item){
			if( this.selected  == item ){
				this.selected = null 
			}else{
				this.selected = item
			}
		},
		save(){
			this.$emit('input', this.selected )
			this.show_modal = false 
		},
		isActive(item){
			return this.selected == item 
		}
	}
}
</script>
<style lang="scss" scoped>
	.vue-parttern{
		&.is-invalid{
			.vue-parttern{
				&-preview{
					border-color: $red;
					background-color: #fbeae5;
					&:focus {
						border-color: $danger;
						box-shadow: 0 0 0 0.2rem rgba(220,53,69,.25);
					}
				}
			}
		}
		&-preview{
			position: relative;
			padding: 4px 0;
			background-color: #fff;
			border: 1px solid #d4d4d4;
			font-size: 13px;
			border-radius: 4px;
			color: #39332E;
			display: flex;
			align-items: center;
			width: 100%;
			height: 30px;
			margin: 0;
			max-width: 100%;
			box-shadow: 0 0 0 1px transparent, 0 1px 0 0 rgba(22, 29, 37, 0.05);
			box-sizing: border-box;
			transition: all 0.2s cubic-bezier(0.64, 0, 0.35, 1);
			appearance: none;
			min-height: 32px;
			outline: none;
			cursor: pointer;
			overflow: hidden;
			img{
				max-width: 100%;
			}
			&:hover{
				color: #39332E;
				text-decoration: none;
				background-color: #e2e6ea;
				border-color: #D4D4D4;
			}
		}
		&.disabled{
			.vue-parttern-preview{
				opacity: 0.5;
				pointer-events: none;
			}
		}
	}
	.parttern-modal{
		&-header{
			border-bottom: 1px solid $border;
			padding: 10px 15px;
		}
		&-body{
			.list-parttern{
				max-height: 300px;
				width: 100%;
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				overflow: hidden auto;
				padding: 15px 30px;
				.item{
					margin-bottom: 20px;
					
					.item-image{
						border: 3px solid transparent;
						transition: all 0.3s ease;
						border-radius: 5px;
						overflow: hidden;
						cursor: pointer;
					}
					img{
						width: 100%;
					}
					&.is-actived{
						
						.item-image{
							border-color: $btn-primary;
						}
					}
				}
			}
		}
		&-footer{
			border-top: 1px solid $border;
			padding: 10px 15px;
		}
	}
</style>